import { FC } from 'react'
import { useSelector } from '../../store'

import './TransparentPreloader.scss'

type PreloaderProps = {
  isGlobal?: boolean
}

const TransparentPreloader: FC<PreloaderProps> = ({}) => {
  const isShow = useSelector(({ transparentPreloader: { isShow } }) => isShow)
  return isShow ? (
    <div className={`transparent-preloader`}>
      <div className='transparent-preloader__spinner' />
    </div>
  ) : (
    <></>
  )
}

export default TransparentPreloader
